export const getNpmStats = async (packages) => {
   const date = new Date().toISOString().slice(0, 10);
   let url = `https://api.npmjs.org/downloads/point/2020-09-01:${date}/`;

   packages.forEach((pkg) => (url += `${pkg},`));

   const data = fetch(url)
      .then((res) => res.json())
      .then((data) => data)
      .catch((e) => console.log(e));
   return await data;
};

export default getNpmStats;
